import { useMemo } from 'react'

import { useMatches } from 'react-router-dom'
import { z } from 'zod'

import { AnchorComponent } from './modes/index.js'

// `forwardRef(...)` returns an object with `typeof === 'object'`, so plain
// `z.function()` rejects it. Accept any callable or `forwardRef`-style object
// — the route handle is produced by `createVisitSiteAnchor`, which already
// type-checks the input.
const anchorComponentSchema = z.custom<AnchorComponent>(
  val => typeof val === 'function' || (typeof val === 'object' && val !== null),
)

const visitSiteAnchorSchema = z.object({
  visitSite: z
    .object({
      anchor: anchorComponentSchema.optional(),
    })
    .optional(),
})

export function useVisitSiteAnchor(): AnchorComponent | undefined {
  const matches = useMatches()

  return useMemo(() => {
    let anchor: AnchorComponent | undefined

    for (const match of matches) {
      const result = visitSiteAnchorSchema.safeParse(match.handle)
      if (result.success && result.data.visitSite?.anchor) {
        anchor = result.data.visitSite.anchor
      }
    }

    return anchor
  }, [matches])
}
